export default __webpack_public_path__ + "static/media/rubik-v12-latin-600.73379a0c.svg";